import React from 'react';
import { FormField } from '../../../../components/FormField';

interface PromotionUnitsProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PromotionUnits: React.FC<PromotionUnitsProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  const units = [
    { name: 'studioCount', dbName: 'studio_count', label: 'Nombre de Studio' },
    { name: 'f2Count', dbName: 'f2_count', label: 'Nombre de F2' },
    { name: 'f3Count', dbName: 'f3_count', label: 'Nombre de F3' },
    { name: 'f4Count', dbName: 'f4_count', label: 'Nombre de F4' },
    { name: 'f5Count', dbName: 'f5_count', label: 'Nombre de F5' },
    { name: 'commercialCount', dbName: 'commercial_units_count', label: 'Nombre de Locaux commerciaux' },
  ];

  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900 dark:text-white">Répartition des lots</h4>
      <div className="grid grid-cols-2 gap-4">
        {units.map(({ name, dbName, label }) => (
          <FormField key={name} label={label}>
            <input
              type="number"
              name={name}
              value={property?.[dbName] ?? formData[name] ?? ''}
              onChange={handleInputChange}
              min="0"
            />
          </FormField>
        ))}
      </div>
    </div>
  );
};